// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._benefitsTooltipTitle_3qxv9_1 {
  /* Typography */
  --pa-benefits-tooltip-title-font-family-inner: var(
    --pa-benefits-tooltip-title-font-family,
    var(--perxis-auto-root-typography-h4-font-family-inner)
  );
  --pa-benefits-tooltip-title-font-size-inner: var(--pa-benefits-tooltip-title-font-size, 16px);
  --pa-benefits-tooltip-title-line-height-inner: var(--pa-benefits-tooltip-title-line-height, 16px);
  --pa-benefits-tooltip-title-font-weight-inner: var(
    --pa-benefits-tooltip-title-font-weight,
    var(--perxis-auto-root-typography-h4-font-weight-inner)
  );
  --pa-benefits-tooltip-title-letter-spacing-inner: var(
    --pa-benefits-tooltip-title-letter-spacing,
    var(--perxis-auto-root-typography-h4-letter-spacing-inner)
  );
  --pa-benefits-tooltip-title-text-transform-inner: var(
    --pa-benefits-tooltip-title-text-transform,
    var(--perxis-auto-root-typography-h4-text-transform-inner)
  );
  --pa-benefits-tooltip-title-color-inner: var(
    --pa-benefits-tooltip-title-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  --perxis-auto-typography-h4-font-family: var(--pa-benefits-tooltip-title-font-family-inner);
  --perxis-auto-typography-h4-font-weight: var(--pa-benefits-tooltip-title-font-weight-inner);
  --perxis-auto-typography-h4-letter-spacing: var(--pa-benefits-tooltip-title-letter-spacing-inner);
  --perxis-auto-typography-h4-text-transform: var(--pa-benefits-tooltip-title-text-transform-inner);
  --perxis-auto-typography-h4-font-size-xxs: var(--pa-benefits-tooltip-title-font-size-inner);
  --perxis-auto-typography-h4-font-size-xs: var(--pa-benefits-tooltip-title-font-size-inner);
  --perxis-auto-typography-h4-font-size-sm: var(--pa-benefits-tooltip-title-font-size-inner);
  --perxis-auto-typography-h4-font-size-md: var(--pa-benefits-tooltip-title-font-size-inner);
  --perxis-auto-typography-h4-font-size-lg: var(--pa-benefits-tooltip-title-font-size-inner);
  --perxis-auto-typography-h4-font-size-xl: var(--pa-benefits-tooltip-title-font-size-inner);
  --perxis-auto-typography-h4-font-size-xxl: var(--pa-benefits-tooltip-title-font-size-inner);
  --perxis-auto-typography-h4-line-height-xxs: var(--pa-benefits-tooltip-title-line-height-inner);
  --perxis-auto-typography-h4-line-height-xs: var(--pa-benefits-tooltip-title-line-height-inner);
  --perxis-auto-typography-h4-line-height-sm: var(--pa-benefits-tooltip-title-line-height-inner);
  --perxis-auto-typography-h4-line-height-md: var(--pa-benefits-tooltip-title-line-height-inner);
  --perxis-auto-typography-h4-line-height-lg: var(--pa-benefits-tooltip-title-line-height-inner);
  --perxis-auto-typography-h4-line-height-xl: var(--pa-benefits-tooltip-title-line-height-inner);
  --perxis-auto-typography-h4-line-height-xxl: var(--pa-benefits-tooltip-title-line-height-inner);
  --perxis-auto-typography-color-darkest: var(--pa-benefits-tooltip-title-color-inner);
}

._benefitsTooltipContent_3qxv9_47 {
  /* Typography */
  --pa-benefits-tooltip-subtitle-font-family-inner: var(
    --pa-benefits-tooltip-subtitle-font-family,
    var(--perxis-auto-root-typography-h5-font-family-inner)
  );
  --pa-benefits-tooltip-subtitle-font-size-inner: var(--pa-benefits-tooltip-subtitle-font-size, 10px);
  --pa-benefits-tooltip-subtitle-line-height-inner: var(--pa-benefits-tooltip-subtitle-line-height, 1.5);
  --pa-benefits-tooltip-subtitle-font-weight-inner: var(--pa-benefits-tooltip-subtitle-font-weight, 400);
  --pa-benefits-tooltip-subtitle-letter-spacing-inner: var(--pa-benefits-tooltip-subtitle-letter-spacing, 0.04em);
  --pa-benefits-tooltip-subtitle-text-transform-inner: var(--pa-benefits-tooltip-subtitle-text-transform, uppercase);
  --pa-benefits-tooltip-subtitle-color-inner: var(
    --pa-benefits-tooltip-subtitle-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --pa-benefits-tooltip-label-font-family-inner: var(
    --pa-benefits-tooltip-label-font-family,
    var(--perxis-auto-root-typography-super-small-font-family-inner)
  );
  --pa-benefits-tooltip-label-font-size-inner: var(
    --pa-benefits-tooltip-label-font-size,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --pa-benefits-tooltip-label-line-height-inner: var(
    --pa-benefits-tooltip-label-line-height,
    var(--perxis-auto-root-typography-super-small-line-height-xxl-inner)
  );
  --pa-benefits-tooltip-label-font-weight-inner: var(
    --pa-benefits-tooltip-label-font-weight,
    var(--perxis-auto-root-typography-super-small-font-weight-inner)
  );
  --pa-benefits-tooltip-label-letter-spacing-inner: var(
    --pa-benefits-tooltip-label-letter-spacing,
    var(--perxis-auto-root-typography-super-small-letter-spacing-inner)
  );
  --pa-benefits-tooltip-label-text-transform-inner: var(
    --pa-benefits-tooltip-label-text-transform,
    var(--perxis-auto-root-typography-super-small-text-transform-inner)
  );
  --pa-benefits-tooltip-label-color-inner: var(
    --pa-benefits-tooltip-label-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  --pa-benefits-tooltip-price-font-family-inner: var(
    --pa-benefits-tooltip-price-font-family,
    var(--perxis-auto-root-typography-super-small-font-family-inner)
  );
  --pa-benefits-tooltip-price-font-size-inner: var(
    --pa-benefits-tooltip-price-font-size,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --pa-benefits-tooltip-price-line-height-inner: var(
    --pa-benefits-tooltip-price-line-height,
    var(--perxis-auto-root-typography-super-small-line-height-xxl-inner)
  );
  --pa-benefits-tooltip-price-font-weight-inner: var(--pa-benefits-tooltip-price-font-weight, 700);
  --pa-benefits-tooltip-price-letter-spacing-inner: var(
    --pa-benefits-tooltip-price-letter-spacing,
    var(--perxis-auto-root-typography-super-small-letter-spacing-inner)
  );
  --pa-benefits-tooltip-price-text-transform-inner: var(
    --pa-benefits-tooltip-price-text-transform,
    var(--perxis-auto-root-typography-super-small-text-transform-inner)
  );
  --pa-benefits-tooltip-price-color-inner: var(
    --pa-benefits-tooltip-price-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
}
._benefitsTooltipContent__tableTitle_3qxv9_117 {
  --perxis-auto-typography-h5-font-family: var(--pa-benefits-tooltip-subtitle-font-family-inner);
  --perxis-auto-typography-h5-font-weight: var(--pa-benefits-tooltip-subtitle-font-weight-inner);
  --perxis-auto-typography-h5-letter-spacing: var(--pa-benefits-tooltip-subtitle-letter-spacing-inner);
  --perxis-auto-typography-h5-text-transform: var(--pa-benefits-tooltip-subtitle-text-transform-inner);
  --perxis-auto-typography-h5-font-size-xxs: var(--pa-benefits-tooltip-subtitle-font-size-inner);
  --perxis-auto-typography-h5-font-size-xs: var(--pa-benefits-tooltip-subtitle-font-size-inner);
  --perxis-auto-typography-h5-font-size-sm: var(--pa-benefits-tooltip-subtitle-font-size-inner);
  --perxis-auto-typography-h5-font-size-md: var(--pa-benefits-tooltip-subtitle-font-size-inner);
  --perxis-auto-typography-h5-font-size-lg: var(--pa-benefits-tooltip-subtitle-font-size-inner);
  --perxis-auto-typography-h5-font-size-xl: var(--pa-benefits-tooltip-subtitle-font-size-inner);
  --perxis-auto-typography-h5-font-size-xxl: var(--pa-benefits-tooltip-subtitle-font-size-inner);
  --perxis-auto-typography-h5-line-height-xxs: var(--pa-benefits-tooltip-subtitle-line-height-inner);
  --perxis-auto-typography-h5-line-height-xs: var(--pa-benefits-tooltip-subtitle-line-height-inner);
  --perxis-auto-typography-h5-line-height-sm: var(--pa-benefits-tooltip-subtitle-line-height-inner);
  --perxis-auto-typography-h5-line-height-md: var(--pa-benefits-tooltip-subtitle-line-height-inner);
  --perxis-auto-typography-h5-line-height-lg: var(--pa-benefits-tooltip-subtitle-line-height-inner);
  --perxis-auto-typography-h5-line-height-xl: var(--pa-benefits-tooltip-subtitle-line-height-inner);
  --perxis-auto-typography-h5-line-height-xxl: var(--pa-benefits-tooltip-subtitle-line-height-inner);
  --perxis-auto-typography-color-dark-light: var(--pa-benefits-tooltip-subtitle-color-inner);
}
._benefitsTooltipContent__tableLabel_3qxv9_138 {
  --perxis-auto-typography-super-small-font-family: var(--pa-benefits-tooltip-label-font-family-inner);
  --perxis-auto-typography-super-small-font-weight: var(--pa-benefits-tooltip-label-font-weight-inner);
  --perxis-auto-typography-super-small-letter-spacing: var(--pa-benefits-tooltip-label-letter-spacing-inner);
  --perxis-auto-typography-super-small-text-transform: var(--pa-benefits-tooltip-label-text-transform-inner);
  --perxis-auto-typography-super-small-font-size-xxs: var(--pa-benefits-tooltip-label-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xs: var(--pa-benefits-tooltip-label-font-size-inner);
  --perxis-auto-typography-super-small-font-size-sm: var(--pa-benefits-tooltip-label-font-size-inner);
  --perxis-auto-typography-super-small-font-size-md: var(--pa-benefits-tooltip-label-font-size-inner);
  --perxis-auto-typography-super-small-font-size-lg: var(--pa-benefits-tooltip-label-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xl: var(--pa-benefits-tooltip-label-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xxl: var(--pa-benefits-tooltip-label-font-size-inner);
  --perxis-auto-typography-super-small-line-height-xxs: var(--pa-benefits-tooltip-label-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xs: var(--pa-benefits-tooltip-label-line-height-inner);
  --perxis-auto-typography-super-small-line-height-sm: var(--pa-benefits-tooltip-label-line-height-inner);
  --perxis-auto-typography-super-small-line-height-md: var(--pa-benefits-tooltip-label-line-height-inner);
  --perxis-auto-typography-super-small-line-height-lg: var(--pa-benefits-tooltip-label-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xl: var(--pa-benefits-tooltip-label-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xxl: var(--pa-benefits-tooltip-label-line-height-inner);
  --perxis-auto-typography-color-dark: var(--pa-benefits-tooltip-label-color-inner);
}
._benefitsTooltipContent__tablePrice_3qxv9_159 {
  --perxis-auto-typography-super-small-font-family: var(--pa-benefits-tooltip-price-font-family-inner);
  --perxis-auto-typography-super-small-font-weight: var(--pa-benefits-tooltip-price-font-weight-inner);
  --perxis-auto-typography-super-small-letter-spacing: var(--pa-benefits-tooltip-price-letter-spacing-inner);
  --perxis-auto-typography-super-small-text-transform: var(--pa-benefits-tooltip-price-text-transform-inner);
  --perxis-auto-typography-super-small-font-size-xxs: var(--pa-benefits-tooltip-price-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xs: var(--pa-benefits-tooltip-price-font-size-inner);
  --perxis-auto-typography-super-small-font-size-sm: var(--pa-benefits-tooltip-price-font-size-inner);
  --perxis-auto-typography-super-small-font-size-md: var(--pa-benefits-tooltip-price-font-size-inner);
  --perxis-auto-typography-super-small-font-size-lg: var(--pa-benefits-tooltip-price-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xl: var(--pa-benefits-tooltip-price-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xxl: var(--pa-benefits-tooltip-price-font-size-inner);
  --perxis-auto-typography-super-small-line-height-xxs: var(--pa-benefits-tooltip-price-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xs: var(--pa-benefits-tooltip-price-line-height-inner);
  --perxis-auto-typography-super-small-line-height-sm: var(--pa-benefits-tooltip-price-line-height-inner);
  --perxis-auto-typography-super-small-line-height-md: var(--pa-benefits-tooltip-price-line-height-inner);
  --perxis-auto-typography-super-small-line-height-lg: var(--pa-benefits-tooltip-price-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xl: var(--pa-benefits-tooltip-price-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xxl: var(--pa-benefits-tooltip-price-line-height-inner);
  --perxis-auto-typography-color-darkest: var(--pa-benefits-tooltip-price-color-inner);
}
._benefitsTooltipContent__table--align-start_3qxv9_180 {
  text-align: start;
}
._benefitsTooltipContent__table--align-end_3qxv9_183 {
  text-align: end;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
